import { Control, Controller } from "react-hook-form";
import { FormControl, FormHelperText, InputLabel, SxProps } from "@mui/material";

import { GvInputMask, INPUT_FIELD_ERROR_HELPER_SX, InputFieldError } from "../../../styles/styledComponents";
import React from "react";

interface InputMaskControllerProps {
  id?: string;
  name: string;
  label: string;
  control: Control<any>;
  fullWidth?: boolean;
  placeholder?: string;
  sx?: SxProps;
  mask: string;
  className?: string;
  disabled?: boolean;
  /**
   * "alert" renders the error in the same InputFieldError box as
   * GvInputController, for forms that mix both controllers.
   */
  errorVariant?: "text" | "alert";
}

const GvInputMaskController = ({
  id,
  name,
  label,
  control,
  fullWidth = true,
  disabled = false,
  placeholder,
  sx,
  mask,
  className,
  errorVariant = "text",
}: InputMaskControllerProps) => {
  const fieldId = id || name;

  return (
    <FormControl fullWidth={fullWidth} sx={sx}>
      {label &&
        <InputLabel
          sx={{ position: "relative" }}
          className={`!capitalize ${className}`}
          htmlFor={fieldId}
        >{label}</InputLabel>
      }
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) =>
          <>
            <GvInputMask
              id={fieldId}
              mask={mask}
              placeholder={placeholder}
              maskPlaceholder={null}
              disabled={disabled}
              className={!!fieldState.error ? "error" : ""}
              {...field}
            />

            {errorVariant === "alert" ?
              fieldState.error?.message && (
                <FormHelperText component="div" sx={INPUT_FIELD_ERROR_HELPER_SX}>
                  <InputFieldError severity="error">{fieldState.error.message}</InputFieldError>
                </FormHelperText>
              ) :
              <div className="text-[#ED7857] text-xs mt-[3px] mb-[-10px]">

                {fieldState.error?.message}
              </div>
            }
          </>
        }
      />
    </FormControl>
  );
};

export default GvInputMaskController;
